module.exports = __webpack_public_path__ + "static/media/hoppe.5a2ae6ff.m4a";